var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (alt, classname, list, loading, styles) {
      pug_html = pug_html + "\u003Cpicture\u003E";
// iterate list
;(function(){
  var $$obj = list;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var img = $$obj[pug_index0];
pug_html = pug_html + "\u003Csource" + (pug.attr("srcset", img.src, true, true)+pug.attr("type", img.type, true, true)) + "\u002F\u003E";
if (img.type === 'image/jpeg') {
pug_html = pug_html + "\u003Cimg" + (pug.attr("class", pug.classes([(classname) ? classname : false], [true]), false, true)+pug.attr("src", img.src, true, true)+pug.attr("width", (img.width) ? img.width : false, true, true)+pug.attr("height", (img.height) ? img.height : false, true, true)+pug.attr("alt", alt, true, true)+pug.attr("loading", (loading) ? loading : false, true, true)+pug.attr("style", pug.style((styles) ? styles : false), true, true)) + "\u002F\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var img = $$obj[pug_index0];
pug_html = pug_html + "\u003Csource" + (pug.attr("srcset", img.src, true, true)+pug.attr("type", img.type, true, true)) + "\u002F\u003E";
if (img.type === 'image/jpeg') {
pug_html = pug_html + "\u003Cimg" + (pug.attr("class", pug.classes([(classname) ? classname : false], [true]), false, true)+pug.attr("src", img.src, true, true)+pug.attr("width", (img.width) ? img.width : false, true, true)+pug.attr("height", (img.height) ? img.height : false, true, true)+pug.attr("alt", alt, true, true)+pug.attr("loading", (loading) ? loading : false, true, true)+pug.attr("style", pug.style((styles) ? styles : false), true, true)) + "\u002F\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fpicture\u003E";
    }.call(this, "alt" in locals_for_with ?
        locals_for_with.alt :
        typeof alt !== 'undefined' ? alt : undefined, "classname" in locals_for_with ?
        locals_for_with.classname :
        typeof classname !== 'undefined' ? classname : undefined, "list" in locals_for_with ?
        locals_for_with.list :
        typeof list !== 'undefined' ? list : undefined, "loading" in locals_for_with ?
        locals_for_with.loading :
        typeof loading !== 'undefined' ? loading : undefined, "styles" in locals_for_with ?
        locals_for_with.styles :
        typeof styles !== 'undefined' ? styles : undefined));
    ;;return pug_html;}

module.exports = template